
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_62063_2911)"}},[_c('path',{attrs:{"d":"M8 9.44v-4l-1 .572M8 9.44H7m1 0h1m1.24 2.76l2.24 2.8m-6.72-2.8L3.52 15M8 2.68V1M1.84 2.68h12.32c.31 0 .56.25.56.56v8.4c0 .31-.25.56-.56.56H1.84a.56.56 0 01-.56-.56v-8.4c0-.31.25-.56.56-.56z","stroke":"#4A4A4A","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_62063_2911"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    